module.exports = __webpack_public_path__ + "img/A1 (1).ef754bfe.jpg";